import { createFileRoute } from '@tanstack/react-router'

import { guardScreen } from '@/app/route-guards'
import { PreparingScreen } from '@/features/documents'
import { preparationQuery } from '@/lib/api/queries/documents'

export const Route = createFileRoute('/_auth/documents/$docId/preparing')({
  beforeLoad: ({ context, params }) => guardScreen(context.queryClient, params.docId, 'preparing'),
  loader: ({ context, params }) => {
    void context.queryClient.prefetchQuery(preparationQuery(params.docId))
  },
  component: PreparingRoute,
})

function PreparingRoute() {
  const { docId } = Route.useParams()
  const navigate = Route.useNavigate()
  return (
    <PreparingScreen
      docId={docId}
      onBack={() => void navigate({ to: '/documents' })}
      onOpenEditor={() => void navigate({ to: '/documents/$docId/edit', params: { docId }, replace: true })}
    />
  )
}
